import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
const apiurl = environment.apiUrl;
const checkIfFile = (value: any) => {
  return value instanceof File;
};
@Injectable({
  providedIn: 'root'
})
export class BizPostService {

  constructor(private readonly http: HttpClient, private readonly errorHandler: ErrorHandlerService,) { }

  getItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/post`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  updateItem(data: any): Observable<any> {
    let formData: FormData = null;
    if (checkIfFile(data.image)) {
      formData = this.FormDataByObject(data, 'image');
      formData.append('image', data.image);
    }
    // Set type to 'Biz Post' for business posts
    data.type = 'Biz Post';
    return this.http.put<any>(`${apiurl}/post/${data.id}`, checkIfFile(data.image) ? formData : data).pipe(
      tap((response) => response)
    );
  }

  updateItemWithImageString(data: any): Observable<any> {
    return this.http.put<any>(`${apiurl}/post/${data.id}`, data).pipe(
      tap((response) => response)
    );
  }

  deleteItem(data: any) {
    return this.http.post<any>(`${apiurl}/post/delete`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getItemById(id: string) {
    return this.http.get<any>(`${apiurl}/post/${id}`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getGroupOption(): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/option`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getGroupItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/1`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getMainCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/2`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/3`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getSubCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/4`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }


  FormDataByObject(obj: any, prop: string): FormData {
    const data = new FormData();
    Object.keys(obj).forEach((key) => {
      if (key !== prop) {
        const value = obj[key];

        if (Array.isArray(value)) {
          data.append(key, JSON.stringify(value));
        } else if (typeof value === 'object' && value !== null) {
          data.append(key, JSON.stringify(value));
        } else {
          data.append(key, value === null ? '' : value);
        }
      }
    });
    return data;
  }
}
